import './LegalPage.css';

export default function RefundPage() {
  return (
    <div className="lp-page">

      <header className="lp-header">
        <div className="lp-inner">
          <h1 className="lp-header__h1">Refund Policy</h1>
          <p className="lp-header__meta">Essential Management Ltd · propertytraining.ai</p>
        </div>
      </header>

      <main className="lp-body">
        <div className="lp-inner">

          {/* Short version callout */}
          <div className="lp-callout">
            <p className="lp-callout__text">
              If the course isn't for you, email us within 14 days of buying it and
              we'll refund you in full. No forms. No questions. No friction.
            </p>
          </div>

          <section className="lp-section">
            <h2 className="lp-section__heading">How it works</h2>
            <p className="lp-section__body">
              Email{' '}
              <a href="mailto:amanda@PropertyTraining.ai" className="lp-link">
                amanda@PropertyTraining.ai
              </a>{' '}
              from the address you used to buy the course. Tell us your name and the
              email address on the order. You don't need to give a reason.
            </p>
            <p className="lp-section__body">
              We'll process your refund through Stripe within five working days. Once
              the refund is issued we'll close your access to the course.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">What's covered</h2>
            <p className="lp-section__body">
              The 14-day window applies to the full one-off price you paid. We don't apply admin fees. There are no partial refunds — it's a full refund or none. To be eligible you must have completed no more than 3 of the 30 lessons.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">After 14 days</h2>
            <p className="lp-section__body">
              After 14 days we don't offer refunds, except where the law requires us
              to. If you're unhappy with the course after 14 days, get in touch anyway
              — we'd still like to hear about it.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">Your statutory rights</h2>
            <p className="lp-section__body">
              This policy is in addition to your rights under UK consumer law. Nothing
              here limits your statutory rights.
            </p>
          </section>

          <section className="lp-section">
            <h2 className="lp-section__heading">Contact</h2>
            <p className="lp-section__body">
              Email{' '}
              <a href="mailto:amanda@PropertyTraining.ai" className="lp-link">
                amanda@PropertyTraining.ai
              </a>
              .
            </p>
          </section>

        </div>
      </main>

    </div>
  );
}